import { ComponentBase } from '@abstracts/component-base';
import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { interval, Subscription } from 'rxjs';
import { ChargingStationStausForCustomerDto } from '../../../dto/chargingStationStausForCustomerDto';
import { ChargingStationsService } from '../../../services/entity/charging-stations.service';
import { ActivatedRoute } from '@angular/router';
import { CustomersService } from '@services/entity/customers.service';

@Component({
  selector: 'app-dashboard-charging-points',
  templateUrl: './dashboard-charging-points.component.html',
  styleUrls: ['./dashboard-charging-points.component.scss']
})
export class DashboardChargingPointsComponent extends ComponentBase implements OnInit, OnDestroy {

  public className = 'DashboardChargingPointsComponent';

  private refreshEntity: Subscription;
  public chargingPointsStatus: ChargingStationStausForCustomerDto
  public customerid: number;
  public isOperator: boolean;
  public isTechnical: boolean;
  public max: number;
  public isLoading: boolean = false;
  constructor(
    private chargingStationsService: ChargingStationsService, 
    private activatedRoute: ActivatedRoute,
    private customersService: CustomersService,
    injector: Injector
  ) { 
    super(injector) 
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.isLoading = true;
    if (this.authenticationService.userHasRole('Operator')) this.isOperator = true;
    if (this.authenticationService.userHasRole('Technical')) this.isTechnical = true;
    this.getCustomerId();
    this.setRefreshCC();
  }

  getCustomerId() {
    this.customersService.getSelectedCustomer().subscribe(result => {
        this.customerid = result.id;
        console.log(this.customerid);
        if(this.customerid) {
          this.refreshStatus();
        }
      }
    );
  }

  refreshStatus() {
    if(this.isOperator || this.isTechnical) {
      this.chargingStationsService.getChargingPointStatusOfCustomer(this.activatedRoute.parent.snapshot.params.key).subscribe(result => {
        this.chargingPointsStatus = result;
        this.max = this.calculateMax()
      }, error => {});
    } else {
      this.chargingStationsService.getChargingPointsStatus().subscribe(result => {
        this.chargingPointsStatus = result;
        this.max = this.calculateMax()
      }, error => {});
    }
  }

  calculateMax() {
    let max = this.chargingPointsStatus.online + this.chargingPointsStatus.charging + this.chargingPointsStatus.busy + this.chargingPointsStatus.offline
    return max;
  }

  setRefreshCC() {
    this.refreshEntity = interval(15000).subscribe(async (val) => {
      this.refreshStatus();
    })
  }
  ngOnDestroy() {
    this.refreshEntity.unsubscribe();
  }
}
